import { useEffect, useState } from 'react'

import { ANIMATION_DURATION, DEFAULT_TEXT, DOT } from './constants/processingText'

interface IProcessingText {
  text?: string
  showDelay?: number
}

export const ProcessingText = ({ text = DEFAULT_TEXT, showDelay = 0 }: IProcessingText) => {
  const [dots, setDots] = useState<string>(DOT)
  const [visible, setVisible] = useState<boolean>(() => showDelay === 0)

  useEffect(() => {
    let timer = 0
    if (visible) {
      timer = window.setInterval(() => {
        setDots((prevValue) => {
          const newValue = prevValue + DOT
          return newValue.length > 3 ? DOT : newValue
        })
      }, ANIMATION_DURATION)
    }
    return () => clearInterval(timer)
  }, [visible])

  useEffect(() => {
    let timer = 0
    if (showDelay > 0) {
      timer = window.setTimeout(() => {
        setVisible(true)
      }, showDelay)
    }
    return () => clearTimeout(timer)
  }, [showDelay])

  if (!visible) {
    return null
  }

  return <>{`${text}${dots}`}</>
}
